import UserScreenConnector from './UserScreenConnector';

export default UserScreenConnector;
